import Big from "big.js";
import { useEffect, useState } from "react";
import { useTaxesPaid } from "../../components/context/TaxesPaidContext";
import { EInputTypes, InputTextCustom } from "medere-ui-framework";
import { TaxType } from "../../interface/orderOfProvision";
import { ETaxType } from "../../interface/interface";

interface TaxInputProps {
    tax:TaxType; // Cambiado de `key` porque es una palabra reservada en React
    currency?: string;
    locale?: string;
    maxFractionDigits?: number;
    min?: number;
}

export const TaxInput: React.FC<TaxInputProps> = ({
    tax,
    currency = "USD",
    locale = "en-US",
    maxFractionDigits = 2,
    min = 0,
}) => {
    const [taxAmount, setTaxAmount] = useState <Big> (Big(0));
    const {updatePaidTax, paidTaxes, updateExemptTaxAmount, updateVatNotTaxedAmount} = useTaxesPaid();
    useEffect(() => {
        const paidTax = paidTaxes.find((t) => t.taxtype === tax.taxType);
        const amount = paidTax?.amount ? paidTax.amount : Big(0)

        if (tax.exemptVatTax)
            updateExemptTaxAmount(Big(amount))
        else if (tax.vatNotTaxed)
            updateVatNotTaxedAmount(Big(amount))
        if (paidTax) setTaxAmount(Big(amount));
        else setTaxAmount(Big(0)); // Resetear a 0 si no hay coincidencia

    }, [paidTaxes, tax.taxType]);
    return (
        <InputTextCustom
            labelClassName="flex-column"
            className="flex-row align-items-center justify-content-between gap-3"
            label={tax.taxName}
            value={taxAmount?Number(taxAmount):Number(0)}
            key={tax.taxType}
            onChange={(event: any) => {
                var rawValue = event?.target?.value;
                if (!rawValue || isNaN(Number(rawValue))) rawValue = 0
                const parsedAmount = Big(rawValue);
                setTaxAmount(parsedAmount);

                updatePaidTax(tax.taxType, tax.taxAccount, tax.taxName, parsedAmount, tax.taxAccountDesc, false);
            }}
            disable={!tax.editable}
            inputType={EInputTypes.NUMBER}
            currency={currency}
            numberMode="currency"
            locale={locale}
            maxFractionDigits={maxFractionDigits}
            min={min}
        />
    );
};
